import { CandidateProfileModel, ICandidateProfile } from "@core/models";
import { SanitationHelper } from "@core/helpers";

export class CandidateProfileDTO extends CandidateProfileModel {
  prepareInformationData() {
    return {
      city: SanitationHelper.sanitizeCityName(this[ICandidateProfile.city]),
      gender: this[ICandidateProfile.gender],
      nationality: this.getNationality(),
      phone: this.getNewPhoneNumber().getPhoneNumber(),
      phone_number: this[ICandidateProfile.newPhone],
      zipcode: this[ICandidateProfile.postalCode],
      address: this[ICandidateProfile.street],
      has_vehicle: this[ICandidateProfile.hasVehicle],
    };
  }
}

export class CandidateAboutDTO {
  constructor({ about } = {}) {
    this.about = about;
  }

  prepareAboutData() {
    return {
      about: this.about,
    };
  }
}

export class CandidateAvatarDTO {
  constructor({ avatar } = {}) {
    this.avatar = avatar;
  }

  prepareProfilePictureData() {
    return {
      avatar: this.avatar,
    };
  }
}

export class CandidateQualitiesDTO {
  constructor({ qualities } = {}) {
    this.qualities = qualities;
  }

  prepareQualitiesData() {
    return {
      qualities: this.getQualitiesId(),
    };
  }

  getQualitiesId() {
    const qualitiesId = this.qualities.map((quality) => quality.id);
    return qualitiesId;
  }
}

export class CandidateSkillsDTO {
  constructor({ skills } = {}) {
    this.skills = skills;
  }

  prepareSkillsData() {
    return {
      skills: this.getSkillsId(),
    };
  }

  getSkillsId() {
    const skillsId = this.skills.map((skill) => skill.id);
    return skillsId;
  }
}
